// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { InvoiceModel } from '../../symbols';

export interface InvoiceListStateModel {
  invoiceList: PaginatorModel<InvoiceModel>;
  loadInvoiceListStatus: PROGRESS_STATUSES;
  lastOpenedDocId: string;
  scrollPosition: number;
}

export const INVOICE_LIST_STATE_DEFAULT: InvoiceListStateModel = {
  invoiceList: {
    data: [],
    meta: null,
    links: null
  },
  loadInvoiceListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastOpenedDocId: null,
  scrollPosition: 0
};
